<template>
     <div class="serviceprovidecontract-search">
          <PageTitle 
                icon="fa fa-clone" 
                main="Record" sub="Service Provider Contract" 
                />
            <b-form 
                v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input 
                id="serviceprovidecontract-id" 
                type="hidden" 
                v-model="serviceprovidecontract.id" />
             <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Contract Date:"
                    label-for="serviceprovidecontract-date_service_provider_contract"
                    >
                    <b-form-input
                    id="serviceprovidecontract-date_service_provider_contract"
                    type="date"
                    v-model="serviceprovidecontract.date_service_provider_contract"
                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                <b-col md="8" sm="12">
                    <b-form-group 
                        label="Service Provider:" 
                        label-for="serviceprovidecontract-service_provider_id_contract">
                        <b-select 
                            id="serviceprovidecontract-service_provider_id_contract"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="serviceproviders" 
                            v-model="serviceprovidecontract.service_provider_id_contract" 
                            />
                    </b-form-group>
                </b-col> 
                 <b-col md="2" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="serviceprovidecontract.blocked_provider_contract" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="serviceprovidecontract-blocked_provider_contract"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="serviceprovidecontract-blocked_provider_contract">
                                Blocked?
                            </label>
                        </div>
                    </div>
                </b-col> 
             </b-row>    
              <b-row>
                 <b-col md="8" sm="12">
                        <b-form-group 
                            label="Comments:" 
                            label-for="serviceprovidecontract-comments_provider_contract">
                        <b-form-textarea id="serviceprovidecontract-comments_provider_contract"
                            :rows="3"
                            :max-rows="6"
                            size="sm"
                            v-model="serviceprovidecontract.comments_provider_contract"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Comments" />
                    </b-form-group>
                </b-col>
             </b-row>

               <b-card class="ownercontract-search-card" >
                 <b-tabs card vertical>
                      <b-tab title="Detail" active>
                             <b-form>
                                  <b-row>
                                     <b-button  
                                        title="Add" 
                                        size="sm" 
                                        class="mb-2 fa fa-plus" 
                                        variant="dark" 
                                        v-if="serviceprovidecontract.id > 0"
                                        @click="openModalItem">
                                    </b-button>
                                  </b-row>
                                  <b-row>
                              <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="serviceprovidecontractitems" 
                            :fields="fieldItem">
                        <template v-slot:cell(actions)="data">
                                <b-button  
                                    title = "Edit" 
                                    size="sm" 
                                    variant="light" 
                                    @click="[loadServiceProviderContractItem(data.item),openModalItem()]" 
                                    class="mr-2 mt-2">
                                    <i class="fa fa-pencil"></i>
                                </b-button>
                                <!--b-button 
                                    title="Delete" 
                                    size="sm" 
                                    variant="light" 
                                    @click="showMsgBoxDeleteActingService(data.item)" 
                                    class="mr-2 mt-2">
                                <i class="fa fa-trash"></i>
                                </b-button-->
                            </template>
                            </b-table>
                            </transition>  
                            </b-row>
                             </b-form>
                      </b-tab>
                 </b-tabs>
              </b-card>

        <br>
         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadOwnerContracts(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row >
            
            <br>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                   <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                           
                              v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Search by service provider name" 
                            class="form-control">
                    </div>
                </div>  
          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                     <!--b-button  
                        v-if="!data.item.confirmed_date_service_contract"
                        title = "Approval" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxApproval(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-check-square-o"></i>
                    </b-button>    
                          <b-button  
                        v-if="!data.item.canceled_date_service_contract"
                        title = "Cancel" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxCanceled(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-ban"></i>
                    </b-button-->        
                    <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
        </b-row>
            <b-modal
            id="modalProviderContractItem"
            ref="modal"
            title-tag="h6"
            title="Service Detail"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveItem"
        >
          <b-form>
                <b-row>
                    <b-col md="12" sm="12">
                       <b-form-group 
                        label="Service:" 
                        label-for="serviceprovidecontractitem-default_service_type_id_contract_item">
                        <b-select 
                            id="serviceprovidecontractitem-default_service_type_id_contract_item"
                            size="sm"
                            :options="defaultservicetypes" 
                            v-model="serviceprovidecontractitem.default_service_type_id_contract_item" 
                            />
                    </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                     <b-col md="3" sm="12">
                        <b-form-group
                            label="Fixed Value:"
                            label-for="serviceprovidecontractitem-fixed_value_contract_item"
                        >
                            <b-form-input
                                id="serviceprovidecontractitem-fixed_value_contract_item"
                                type="number"
                                v-model="serviceprovidecontractitem.fixed_value_contract_item"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Hourly Rate:"
                            label-for="serviceprovidecontractitem-hourly_rate_contract_item"
                        >
                            <b-form-input
                                id="serviceprovidecontractitem-hourly_rate_contract_item"
                                type="number"
                                v-model="serviceprovidecontractitem.hourly_rate_contract_item"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
          </b-form>
        </b-modal>
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'ServiceProviderContractSearch',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                serviceprovidecontract: {},
                serviceprovidecontractitem: {},
                serviceprovidecontractitems:[],
                serviceproviders:[],
                serviceprovidecontracts: [],
                serviceprovidecontractcontracts:[],
                defaultservicetypes:[],
                perPage: 5,
                currentPage: 1,
                 isBusy: false,
                 showTable: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                {
                    key: 'date_service_provider_contract',label: 'Contract Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('MM-DD-YYYY') : '',variant: 'light'
                    },
                    { key: 'name_service_provider', label: 'Service Provider', sortable: false ,variant: 'light'},
                    { key: 'comments_provider_contract', label: 'Comments', sortable: false ,variant: 'light'},
                    { key: 'blocked_provider_contract', label: 'Blocked', sortable: false,
                        formatter: value => value ? 'yes' : 'No' ,variant: 'light'}, 
               
                { key: 'actions', label: 'Action',variant: 'light' },
                //{ key: 'accesses', label: 'Acessos',variant: 'secondary' }
                ],
                fieldItem: [
                    { key: 'name_default_service_type', label: 'Service', sortable: false ,variant: 'light'},   
                    { key: 'fixed_value_contract_item', label: 'Fixed Value', sortable: false ,variant: 'light'},   
                    { key: 'hourly_rate_contract_item', label: 'hourly Rate', sortable: false ,variant: 'light'},   
                    { key: 'actions', label: 'Action',variant: 'light' }
                ]
               
            }
        },
        computed: {
            filteredList() {
                return this.serviceprovidecontracts.filter(serviceprovidecontract => {
                    return serviceprovidecontract.name_service_provider.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.serviceprovidecontracts.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
             async showMsgBoxApproval(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to approval the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.approval(item)
                    }
                })
            },
             async showMsgBoxCanceled(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to canceled the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.approval(item)
                    }
                })
            },
            formatDateTime(date) {
                return moment(date)
                    .utcOffset(-3)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadOwnerContracts(){
                const url = `${baseApiUrl}/serviceprovidecontractsbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.serviceprovidecontracts = res.data
                      this.isBusy = false
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.serviceprovidecontract = {}
                    this.serviceprovidecontractitem = {}
                    this.serviceprovidecontractitems = []
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.loadOwnerContracts()              
                this.serviceprovidecontract = {}
            },
            openModalItem() {
                this.$bvModal.show('modalProviderContractItem')
            },
            loadServiceProviderContractItem(item){
                this.serviceprovidecontractitem = {...item}
            },
            async approval(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/serviceprovidecontractsapproval/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerContracts()

                        })
                        .catch(showError)

           },
             async canceled(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/serviceprovidecontractscanceled/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerContracts()

                        })
                        .catch(showError)

           },
            async save() {

                const method = this.serviceprovidecontract.id ? 'put' : 'post'
                const id = this.serviceprovidecontract.id ? `/${this.serviceprovidecontract.id}` : ''

                if(this.serviceprovidecontract.id){
                    this.serviceprovidecontract.update_date_service_contract = this.formatDateTime(Date())
                    this.serviceprovidecontract.update_user_service_contract = this.user.id
                }else{
                    this.serviceprovidecontract.user_id_provider_contract = this.user.id
                    this.serviceprovidecontract.company_id_service_provider_contract = this.compan.id
                }

                await axios[method](`${baseApiUrl}/serviceprovidecontracts${id}`, this.serviceprovidecontract)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                    const id = this.serviceprovidecontract.id
                    axios.delete(`${baseApiUrl}/serviceprovidecontracts/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
            async saveItem(){

                const method = this.serviceprovidecontractitem.id ? 'put' : 'post'
                const id = this.serviceprovidecontractitem.id ? `/${this.serviceprovidecontractitem.id}` : ''

                if(this.serviceprovidecontractitem.id){
                    this.serviceprovidecontract.update_date_contract_item = this.formatDateTime(Date())
                    this.serviceprovidecontract.update_user_id_contract_item = this.user.id
                }else{
                    this.serviceprovidecontractitem.user_id_contract_item = this.user.id
                }

                await axios[method](`${baseApiUrl}/serviceprovidecontractitems${id}`, this.serviceprovidecontractitem)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadServiceProviderContractItems()
                    })
                    .catch(showError)
            },
            loadOwner(serviceprovidecontract, mode = 'save') {
                this.mode = mode
                 if(serviceprovidecontract.date_service_provider_contract) serviceprovidecontract.date_service_provider_contract = this.formatDate(serviceprovidecontract.date_service_provider_contract)
                this.serviceprovidecontract = { ...serviceprovidecontract }
                this.loadServiceProviderContractItems()
     
            },
            loadServiceProvider(){
                const url = `${baseApiUrl}/serviceprovidersbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.serviceproviders = res.data.map(type => {
                        return { value: type.id, text: type.name_service_provider }
                    })
                
                })
            },
            loadServiceProviderContractItems(){
                const url = `${baseApiUrl}/serviceprovidecontractitemsbycontract/${this.serviceprovidecontract.id}`
                axios(url).then(res =>{
                     this.serviceprovidecontractitems = res.data
                })
            },
             loadDefaultServiceRequests() {
                const url = `${baseApiUrl}/defaultservicetypesbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.defaultservicetypes = res.data.map(type => {
                        return { value: type.id, text: type.name_default_service_type }
                    })
                })
            },

        },
        mounted(){
            this.loadOwnerContracts()
            this.loadServiceProvider()
            this.loadDefaultServiceRequests()
            this.showTable = true
        }
}
</script>

<style>


    .serviceprovidecontract-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .serviceprovidecontract-search button{
        font-size: 0.75rem;
    }

     .serviceprovidecontract-search select{
        font-size: 0.75rem;
    }

    .serviceprovidecontract-search input{
        font-size: 0.75rem;
    }

    .serviceprovidecontract-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }

      .serviceprovidecontract-search textarea{
            font-size: 0.75rem;
        }


      #modalImmobile {
        font-size: 0.75rem;
    }

    #modalProviderContractItem button{
        font-size: 0.75rem;
    }

     #modalProviderContractItem input{
        font-size: 0.75rem;
    }

      #modalProviderContractItem select{
        font-size: 0.75rem;
    }

      #modalProviderContractItem label{
        font-size: 0.75rem;
        color: black;
    }




    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
